import { LabourRateBasis } from './labour-rate-basis.model';
import { ServiceGroup } from './service-group.model';
export class WorkOrderLabour {
  addedByGmWorkbench: boolean = null;
  caseFromQuote: boolean = null;
  caseStatusId: string = null;
  chargeoutRateBasisId: number = null;
  costSubTotal: number = null;
  creditMemo: string = null;
  estimatedTime: number = null;
  embedded?: WorkOrderLabourEmbed = null;
  gmDiscountPercent: number = null;
  gmJobId: string = null;
  gmLabourDiscountPercent: number = null;
  gmMismatch: boolean = null;
  gmPartDiscountPercent: number = null;
  gmRosyncLineDeleted: boolean = null;
  gmWorkbenchPartsAmount: number = null;
  gst: number = null;
  id: number = null;
  initialLabourRate: number = null;
  labourMatrixFlag: boolean = null;
  labourRateChanged: boolean = null;
  labourRateModifiedBy: string = null;
  labourOp: string = null;
  matrixOriginalRate: number = null;
  modifiedByTechnicianWorkbench: boolean = null;
  partKitsMaintenanceId: number = null;
  pst: number = null;
  quoteCaseNumber: number = null;
  quoteFlag: string = null;
  rate: number = null;
  rateTypeId: string = null;
  recommendedHours: number = null;
  roSyncInventoryIdRequested: string = null;
  sequence: number = null;
  serviceFreeform: string = null;
  serviceGroupCleared: boolean = null;
  serviceGroupId: string = null;
  serviceName: string = null;
  shopSupplyFlag: string = null;
  subTotal: number = null;
  submitFlag: string = null;
  subTransactionTypeId: string = null;
  taxable: boolean = null;
  technicianStory: string = null;
  technicianRateBasisId: number = null;
  total: number = null;
  totalHours: number = null;
  updatedByUbiquiti: boolean = null;
  warrantyCase: number = null;
  warrantyTypeId: string = null;
  warrantySubmissionTypeId: string = null;
  workOrderId: number = null;
  recommendHours: string = null;

  constructor(obj?: WorkOrderLabour) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

class WorkOrderLabourEmbed {
  chargeOutRateBasis?: LabourRateBasis = null;
  serviceGroup?: ServiceGroup = null;
  technicianPayRateBasis?: LabourRateBasis = null;
}
